/**
 * API呼び出しヘルパー（デジタルツール認証トークンを自動付与）
 */

import { shouldUseSSOAuth } from './env';

let digitalToolsAuthInstance = null;

export const setDigitalToolsAuth = (auth) => {
  digitalToolsAuthInstance = auth;
};

function isAuthProxyUrl(url) {
  return url.includes('/api/auth/digital-tools/');
}

export const apiCall = async (endpoint, options = {}) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
  const url = `${API_BASE_URL}${endpoint}`;

  try {
    const headers = {
      Accept: 'application/json',
      ...(options.headers || {}),
    };

    const digitalToolsUrl = process.env.REACT_APP_DIGITAL_TOOLS_URL;
    const isDigitalToolsEndpoint = digitalToolsUrl && url.startsWith(digitalToolsUrl);
    const isAuthProxy = isAuthProxyUrl(url);
    const attachBearer =
      shouldUseSSOAuth() &&
      !isDigitalToolsEndpoint &&
      !isAuthProxy &&
      digitalToolsAuthInstance &&
      digitalToolsAuthInstance.isAuthenticated();

    if (attachBearer) {
      const token = await digitalToolsAuthInstance.getAuthToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    }

    if (!(options.body instanceof FormData)) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }

    const response = await fetch(url, {
      ...options,
      headers,
    });

    if (
      shouldUseSSOAuth() &&
      response.status === 401 &&
      !isDigitalToolsEndpoint &&
      !isAuthProxy &&
      digitalToolsAuthInstance
    ) {
      const refreshedToken = await digitalToolsAuthInstance.getAuthToken(true);
      if (refreshedToken) {
        headers.Authorization = `Bearer ${refreshedToken}`;
        const retry = await fetch(url, {
          ...options,
          headers,
        });
        if (retry.status !== 401) {
          return retry;
        }
      }
      // 再検証後も 401 → SSO 再ログイン（App の unauthenticated 処理へ）
      digitalToolsAuthInstance.clearAuthFromStorage();
      digitalToolsAuthInstance.setAuthState('unauthenticated');
    }

    return response;
  } catch (error) {
    console.error('API呼び出しエラー:', error);
    throw error;
  }
};

/**
 * 開発プロキシが "Proxy error: ..." のプレーンテキストを返すことがある。
 * JSON でない応答は null（呼び出し側で利用不可扱い）。
 */
export async function readJsonResponse(response) {
  const text = await response.text();
  if (!text) {
    return null;
  }
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}
